import { render, staticRenderFns } from "./DrawSelection.vue?vue&type=template&id=1231b1d2&scoped=true"
import script from "./DrawSelection.vue?vue&type=script&lang=js"
export * from "./DrawSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1231b1d2",
  null
  
)

export default component.exports